import { Button, Col, Form, Modal, ModalTitle, Row } from "react-bootstrap";
import moment from "moment";
import useSessionStorage from "../../../hooks/useSessionStorage";
import { useEffect, useState, useRef } from 'react';
import './sms.css'
import { MdOutlineClose } from 'react-icons/md';
import { IoMdPaperPlane } from 'react-icons/io'

const SMSModal = ({
    showModal,
    data,
    handleSave,
    handleClose,
    formData,
    handleForm,
    listData,
    sendAllSms,
    groupSMSSaveFlag,
    smsHistoryMainPageFlag,
    smsShiftCoveragePageFlag,
    candidateName
}) => {

    const storage = useSessionStorage();
    const login = storage.getItem("login");
    const messagesEndRef = useRef(null)

    function emailTimeDisplay(dbDate) {
        dbDate = new moment(dbDate);
        let currentDate = new moment();
        if (currentDate.isSame(dbDate, "day")) {
            return dbDate.format("h:mm a");
        } else if (currentDate.isSame(dbDate, "year")) {
            return dbDate.format("MMM DD");
        } else {
            return dbDate.format("MM/DD/YYYY");
        }
    }

    useEffect(() => {
        if (showModal && !groupSMSSaveFlag) {
            setTimeout(() => window.setUpChatWindow(), 2000);
            const container = document.querySelector('#ChatBody');
            container.scrollTop = container.scrollHeight - container.clientHeight;
        }
    }, [groupSMSSaveFlag, showModal])

    // useEffect(()=> {
    //     setTimeout(() => window.setUpChatWindow(), 2000);
    //     const container = document.querySelector('#ChatBody');
    //     container.scrollTop = container.scrollHeight - container.clientHeight;
    // },[])


    const formatAMPM = (date) => {
        const newDate = new Date(date);
        var hours = newDate.getHours();
        var minutes = newDate.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    return (
        <>
            {groupSMSSaveFlag ? <div id="userLocationModal">
                <Modal size="lg" show={showModal} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>SMS Compose</Modal.Title>
                        <div type="button"
                            // onClick={() => sendAllSms()}
                            onClick={handleClose}
                        ><i class="fa fa-close fa-lg"></i></div>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="row">
                            <div className="col-sm-12">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="from-candidate">
                                            From Employer<span class="required">*</span>
                                        </label>
                                        <div>
                                            {login.fullName}{" "}{login.cellPhoneNumber}
                                        </div>
                                        <label htmlFor="to-candidate" className="mt-3">
                                            To Candidate<span class="required">*</span>
                                        </label>
                                        <br />
                                        {groupSMSSaveFlag === false || smsHistoryMainPageFlag === true || smsShiftCoveragePageFlag === true ?
                                            <p>
                                                {data?.name || data?.candidateName || `${data?.candidateFirstName} ${data?.candidateLastName}`} {data?.phone || data?.candidatePhone || data?.cellPhoneNumber}
                                            </p> :
                                            data?.map && data?.map((item) => (
                                                <span>{item?.name} {`(${item?.phone})`},</span>
                                            ))
                                        }
                                    </div>
                                    <Row>
                                        <Form.Group as={Col} className="md-6" controlId="subject">
                                            <Form.Label>SMS:</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={5}
                                                type="text"
                                                value={formData?.sms}
                                                onChange={(e) => {
                                                    handleForm("sms", e.currentTarget.value);
                                                }}
                                                placeholder="sms"
                                            />
                                        </Form.Group>
                                    </Row>
                                </form>
                                <div className="text-end mt-3 mb-3"> <Button variant="primary" onClick={() => handleSave()}>
                                    Send SMS
                                </Button> </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-outline-primary" onClick={handleClose}>
                            Close
                        </button>

                    </Modal.Footer>
                </Modal>
            </div>
                :
                showModal ? <div className="chatbox-modal">
                    <div className="chatbox-modal-content">
                        <section className="chatbox">
                            <header className="chatbox-header">
                                <div className="header-title-icon">
                                    <p className="avatar-icon bg-success">
                                        {candidateName ? candidateName?.charAt(0) : ''}
                                    </p>
                                    <div className="avatar-details">
                                        {candidateName ? candidateName : ''}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <div type="button"
                                    // onClick={() => sendAllSms()}
                                    >
                                        {/* <i class="fa fa-play fa-lg"></i> */}
                                    </div>
                                    <div
                                        onClick={() => { handleClose() }}
                                        className="header-close-icon"
                                    >
                                        <MdOutlineClose />
                                    </div>
                                </div>
                            </header>
                            <div className="chatbox-body" id="ChatBody">
                                <>
                                    {/* <label className="main-chat-time">
                                    <span>date123</span>
                                </label> */}

                                    {Array.isArray(listData) && listData?.length ? listData?.map((val) => {
                                        return val?.fromCandidate ? (
                                            <div className="media chat-left">
                                                <div className="header-title-icon me-4">
                                                    <p className="avatar-icon bg-success">
                                                        {candidateName ? candidateName?.charAt(0) : ''}
                                                    </p>
                                                </div>
                                                <div className="media-body mb-4">
                                                    <div className="main-msg-wrapper mb-2">
                                                        {val?.messageBody}
                                                    </div>
                                                    <span className="time-status">
                                                        {val?.messageDateToDisplay}
                                                    </span>
                                                    <div></div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="media flex-row-reverse chat-right ">
                                                <div className="header-title-icon ms-4">
                                                    <p className="avatar-icon bg-primary ">
                                                        {val?.messageFromName ? val?.messageFromName?.charAt(0) : ''}
                                                    </p>
                                                </div>
                                                <div className="media-body mb-4 ">
                                                    <div className="main-msg-wrapper d-block mb-2">
                                                        {val?.messageBody}
                                                    </div>
                                                    <span className="time-status">
                                                        {val?.messageDateToDisplay}
                                                    </span>
                                                    <div></div>
                                                </div>
                                            </div>
                                        );
                                    }) : ''}
                                    <div ref={messagesEndRef} />
                                </>
                            </div>

                            <footer className="chatbox-footer">
                                <input
                                    type="text"
                                    id="send"
                                    value={formData?.sms}
                                    onChange={(e) => {
                                        handleForm("sms", e.currentTarget.value);
                                    }}
                                    className="form-control flex-2 mb-0"
                                    placeholder="Type your message here...."
                                />
                                <div onClick={() => handleSave()} className="footer-send-icon bg-primary pl-4 ">
                                    <IoMdPaperPlane className="paper-icon" />
                                </div>
                            </footer>
                        </section>
                    </div>
                </div> : ""
            }
        </>
    );
};

export default SMSModal;
